import { CompanyAutoCompletionModel } from '@/__generated';
import { t } from 'i18next';
import { GUID } from '@/constants';
import { useDebounce } from '@/hooks/useDebounce';
import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import { uniqBy } from 'lodash';
import React from 'react';

interface Props extends SelectProps<any> {
  allowSelectAll?: boolean;
  ids?: string[];
}

export default function CompanyInput({ allowSelectAll, maxTagCount = 'responsive', ids, onChange, ...props }: Props) {
  const [searchValue, setSearchValue] = React.useState<string>('');

  const [companies, setCompanies] = React.useState<CompanyAutoCompletionModel[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [preCompanies, setPreCompanies] = React.useState<CompanyAutoCompletionModel[]>([]);

  React.useEffect(() => {
    if (ids?.length) {
      apiSdk.CompanyService.getAutoCompletion({ ids: ids }).then(res => setPreCompanies(res));
    } else {
      setPreCompanies([]);
    }
  }, [ids]);
  const getData = (searchText: string) => {
    setLoading(true);
    apiSdk.CompanyService.getAutoCompletion({
      searchText: searchText || undefined,
    })
      .then(res => {
        setCompanies(res || []);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchValueDebounce = useDebounce(searchValue, 300);

  React.useEffect(() => {
    getData(searchValueDebounce);
  }, [searchValueDebounce]);

  const options: any[] = React.useMemo(() => {
    let companiesData =
      [...preCompanies, ...companies]?.map(c => {
        return {
          label: c.name,
          value: c.id,
        };
      }) || [];
    companiesData = uniqBy(companiesData, x => x.value);

    if (allowSelectAll) {
      companiesData = [{ label: t('ALL'), value: GUID.EMPTY }, ...companiesData];
    }
    return companiesData;
  }, [companies, allowSelectAll, preCompanies]);

  return (
    <Select
      {...props}
      loading={loading}
      showSearch
      onSearch={v => setSearchValue(v)}
      allowClear
      onChange={onChange}
      options={options}
      filterOption={false}
    ></Select>
  );
}
